import { Typography } from '@mui/material';
import { useState } from 'react';

import { CustomTextAreaNoForm } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';

export type IPvDetailCellPrimaryTextProps = { ip: string };

const IPvDetailCellPrimaryText: React.FC<IPvDetailCellPrimaryTextProps> = ({
  ip,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const ipLength = ip?.length || 0;

  return (
    <>
      {ipLength <= 15 ? (
        <Typography variant="body1" color="textPrimary" title={ip}>
          {ip}
        </Typography>
      ) : (
        <>
          <Typography
            variant="body1"
            color="textPrimary"
            noWrap
            title={ip}
            onClick={() => setOpen(true)}
            style={{
              cursor: 'pointer',
            }}
          >
            {ip}
          </Typography>
        </>
      )}

      {/* ------------ MODAL ------------ */}
      <ScrollableDialogProps
        open={open}
        title="IP"
        onClose={() => setOpen(false)}
        cancelTextBtn="Cerrar"
        contentNode={
          <>
            <CustomTextAreaNoForm
              label="IP"
              value={ip}
              rows={5}
              defaultValue={ip}
            />
          </>
        }
      />
    </>
  );
};

export default IPvDetailCellPrimaryText;
